<template>
    <div>
        <o-table ref="tableList" :enable-view="false" default-sort-by="id" default-sort-by-direction="desc" :title="$t('sandoz.kuko_condition_groups')"
                 :url="'/api/kuko_condition_groups'">
            <template slot="filter">
              <div class="d-flex">
                <div>
                    <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                        <o-filter-text :title="$t('sandoz.condition_group')" column="condition_group"></o-filter-text>
                    </o-filter>
                </div>
            </div>
            </template>
            <template slot="head">
              <o-table-header column="condition_group" :sortable="true">{{ $t('sandoz.condition_group') }}</o-table-header>
              <o-table-header column="customer_external_id" :sortable="false">{{ $t('sandoz.customer_external_id') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
              <td>{{props.item.condition_group}}</td>
              <td>{{props.item.customer_external_id}}</td>
            </template>
            <template slot="body-controls" slot-scope="props">
              <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                  <o-delete method="delete" v-if="!!user.is_super_user" :url="'/api/kuko_condition_groups/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
                  <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                    <fa icon="pencil-alt"/>
                  </router-link>
                </div>
              </td>
            </template>
        </o-table>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  data: () => ({
    types: []
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  created() {
    this.types = [
      {value: 'normal', text: this.$i18n.t('sandoz.normal')},
      {value: 'chargeback', text: this.$i18n.t('sandoz.chargeback')},
    ]
  }
}
</script>
